<template>
  <div class="edit-user-container">
    <h1 class="page-header text-center">{{ pageAction }} user</h1>
    <div v-if="alert" class="error-message text-center callout alert">{{ alert }}</div>
    <div v-if="isEdit" class="text-center data-title">{{ userEmail }}</div>
    <div v-else class="row">
      <div class="small-6 columns small-centered">
        <email-input
            inputId="new-email"
            labelText="email"
            fieldToReturn="newUserEmail"
            placeholder="enter user's email"
            @setEmail="setData">
        </email-input>
      </div>
    </div>
    <access-pages 
        :userAbilitiesValue="thisUserAbilitiesValue" 
        @updateUserAbilities="setData">
    </access-pages>
    <div class="row">
      <div class="small-12 columns center-button">
        <input 
            type="submit" 
            name="save-user" 
            value="save user" 
            id="save-user"
            class="submit-save button larger" 
            @click.prevent="saveUser">
      </div>
    </div>
    <router-link to="/users" exact class="link-delete cancel-link">cancel</router-link>
    <div v-if="isEdit && hasAccess(userAbilitiesValue, 'MANAGE_USERS_CREATE')" @click="removeUser" class="link-delete delete-user-link float-right">delete user</div>
  </div>
</template>

<script>
  import AxiosMixin from '../../mixins/AxiosMixin'
  import router from '../../router/index'
  import { mapGetters } from 'vuex'
  import AccessPages from '../../components/Users/AccessPages'
  import UserAbilitiesMixin from '../../mixins/UserAbilitiesMixin' 
  import EmailInput from '../../components/FormItems/EmailInput'
  
  export default {
    name: 'UsersEdit',

    components: {
      AccessPages,
      EmailInput,
    },

    mixins: [AxiosMixin, UserAbilitiesMixin],

    data() {
      return {
        alert: null,
        newUserEmail: '',
        user: null,
        userAbilities: [],
        userId: null
      }
    },
    
    computed: {
      ...mapGetters([
        'userAbilitiesValue'
      ]),

      isEdit: function () {
        return !!this.userId
      },

      pageAction: function () {
        return this.isEdit ? 'edit' : 'new'
      },

      userEmail: function () {
        return this.user?.email
      },

      thisUserAbilitiesValue: function () {
        return this.user?.user_permissions
      }
    },

    methods: {
      setUserId() {
        this.userId = this.$route?.params?.id
      },

      getUser() {
        if (!this.userId) { return }

        this.axiosMethod({
          methodType: 'get', 
          url: `/api/v3/users/${this.userId}`, 
          onSuccess: this.onGetUserSuccess, 
          onError: this.setAlert
        })
      },

      onGetUserSuccess(data) {
        this.user = data
      },

      removeUser(user) {
        if (!this.userId) { return }

        if (window.confirm('are you sure you want to delete this user?')) {
          this.axiosMethod({
            methodType: 'delete', 
            url: `/api/v3/users/${this.userId}`, 
            onSuccess: this.removeUserSuccessHandler,
            onError: this.setAlert
          })
        }
      },

      removeUserSuccessHandler() {
        router.push({path:'/users'})
      },

      saveUser() {
        if (!this.validUser()) { return }

        const baseUrl = '/api/v3/users',
            url = this.isEdit ? `${baseUrl}/${this.userId}` : baseUrl,
            methodType = this.isEdit ? 'patch' : 'post'
        let permissions = this.userAbilities.reduce((a, b) => a + b, 0n)

        // legacy stuff, replaced and removed in later tickets
        permissions += 31n

        this.axiosMethod({
          methodType: methodType, 
          url: url, 
          params: { permissions: permissions.toString(), email: this.newUserEmail },
          onSuccess: this.saveUserSuccessHandler,
          onError: this.saveUserErrorHandler,
        })
      },

      saveUserErrorHandler(error) {
        this.newUserEmail = ''
        this.setAlert()
      },

      saveUserSuccessHandler(data) {
        const errors = Object.values(data.errors),
            hasErrors = errors.length > 0
        if (hasErrors) {
          this.setAlert(errors[0][0])
          return
        }
        router.push({path:'/users'})
      },

      setAlert(message = 'there was an error please refresh & try again') {
        this.alert = message;
      },

      setData(field, value) {
        this[field] = value
      },

      validUser() {
        const invalidEmail = this.isEdit ? false : this.newUserEmail.length === 0,
            invalidAbilities = this.userAbilities.length === 0,
            errorMessage = invalidEmail ? 'must enter an email' : 'must select a permission'
        
        if (invalidEmail || invalidAbilities) {
          this.setAlert(errorMessage)
          return false
        }
        return true
      },
    },

    created() {
      this.$store.dispatch('LOAD_CURRENT_USER')
      this.setUserId()
      this.getUser()
    },
  }
</script>
